/**
 * Client-side subtotals for grouped results.
 *
 * The backend orders grouped rows by the group-by fields (prepending them to
 * any user sort), so a subtotal row can be inserted whenever the first
 * group-by value changes. Only the columns the server totals are summed.
 * Subtotals are only shown when the whole result fits on one page; otherwise
 * they would be partial.
 */

export function canShowSubtotals(result, groupBy) {
  if (!result || !Array.isArray(groupBy) || groupBy.length < 2) return false;
  if (result.total_rows == null) return false;
  return result.total_rows <= result.page_size;
}

export function buildDisplayRows(result, groupBy) {
  const rows = result?.rows || [];
  if (!canShowSubtotals(result, groupBy)) {
    return rows.map((row, i) => ({ kind: 'data', row, key: `${result?.page || 1}-${i}` }));
  }
  const firstKey = groupBy[0];
  const sumKeys = Object.keys(result.totals || {}).filter((k) => k !== '_rows');
  const out = [];
  let current;
  let started = false;
  let sums = {};
  let count = 0;

  const flush = () => {
    if (!started) return;
    out.push({ kind: 'subtotal', groupValue: current, sums: { ...sums }, count, key: `sub-${out.length}` });
  };

  rows.forEach((row, i) => {
    const value = row[firstKey];
    if (!started || value !== current) {
      flush();
      current = value;
      started = true;
      sums = {};
      count = 0;
    }
    sumKeys.forEach((k) => {
      const v = Number(row[k]);
      if (!Number.isNaN(v)) sums[k] = (sums[k] || 0) + v;
    });
    count += 1;
    out.push({ kind: 'data', row, key: `${result.page || 1}-${i}` });
  });
  flush();
  return out;
}
